var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom_tab hidden-sm-and-up"},[_c('img',{staticStyle:{"width":"40%"},attrs:{"src":require("../../assets/img/home/logo.svg"),"alt":""}}),_c('img',{attrs:{"src":require("../../assets/img/qr-hscz.922c1e6.png"),"alt":""}}),_c('p',[_vm._v("长按识别二维码，关注极智峰公众号")]),_c('div',{staticClass:"phone"},[_c('span',[_vm._v("联系电话：400-6600-138")])])])
}]

export { render, staticRenderFns }